import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'modal.status.pending.title',
        defaultMessage: 'Card application in progress',
    },
    subtitle: {
        id: 'modal.status.pending.subtitle',
        defaultMessage: 'You can close this window. Your card will appear in the Cards section shortly.',
    },
    button: {
        id: 'modal.status.pending.button',
        defaultMessage: 'Close',
    },
})
